import React from "react";
import {observer} from "mobx-react-lite"
import "./BrandBanner.css"

const BrandBanner = observer(({store}) => {
    return (
        <div >
            <div className="product_info">
                <div className="product_info_text"> Product <br/><div className="information_text">INFORMATION </div></div>
            <img alt={"logo"} src={store.brandImage} className="product_logo"/>
            </div>
            <div className="product_divider"/>
        </div>
    )
})

export default BrandBanner;
